import { render, staticRenderFns } from "./CategoryTemplate.vue?vue&type=template&id=50936ebc"
import script from "./CategoryTemplate.vue?vue&type=script&lang=js"
export * from "./CategoryTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports